import React, { useEffect } from "react";
import amplifyConfig from "../../configuration/amplify.config";
import awsAuthConfig from "../../configuration/amplify.auth";
import { Amplify, Auth } from "aws-amplify";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { authenticate } from "./thunk";
import LoaderBox from "../loader/LoaderBox";

Amplify.configure(amplifyConfig);
Auth.configure({ oauth: awsAuthConfig });
const ONE_HOUR = 3600;
const TIMER_INTERVAL = ONE_HOUR * 999;

export interface IAuthWrapperProps {
    children?: React.ReactNode;
}

export const AuthWrapper: React.FC<IAuthWrapperProps> = ({ children }) => {
    const dispatch = useAppDispatch();
    const { isAuthenticated, expiration } = useAppSelector(state => state.auth);

    useEffect(() => {
        if (expiration > 0) {
            const interval = setInterval(() => {
                const currentTimestamp = new Date().getTime() / 1000;
                const timeRemaining = expiration - currentTimestamp;
                if (timeRemaining <= ONE_HOUR) {
                    dispatch(authenticate(true));
                    clearInterval(interval);
                }
            }, TIMER_INTERVAL);
        } else {
            dispatch(authenticate(false));
        }
    }, [dispatch, expiration]);

    if (isAuthenticated) {
        return <React.Fragment>{children}</React.Fragment>;
    } else {
        return <LoaderBox loadingText={"Authenticating"} />;
    }
};
